/**
 * Created by Alex on 6/06/19.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError, concatMap, switchMap } from 'rxjs/operators';

import { AppState } from '..';
import { EntityScreenActionTypes } from '../actions/entity-screen.actions';
import { ScreenHelperService } from '../../services/screen-helper.service';

@Injectable()
export class EntityScreenEffect {
    constructor(
        private _actions$: Actions,
        private _screenHelperService: ScreenHelperService,
        private _store: Store<AppState>
    ) { }

    loadEntityScreensEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EntityScreenActionTypes.LOAD),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._screenHelperService.getEntityScreens(payload).pipe(
                map(response => {
                    return ({
                        type: EntityScreenActionTypes.LOAD_SUCCESS,
                        payload: response
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return of({
                type: EntityScreenActionTypes.LOAD_FAILED,
                payload: err.message
            });
        })
    ));
}
